<template>
    <div id="tabstrip">
        <ul class="tabs">
            <li id="tab_home" class="tab">
                <span class="tab-text tab-option">
                    <a href="" class="tab-link" @click="(evt) => route(evt, { link: '/menu' })">
                        {{ $t('TAB_HOME') }}
                    </a>
                </span>
            </li>
            <li
                v-for="parentProduct in menu"
                :id="'tab_' + parentProduct.name"
                :class="{ 'dropdown-tab': parentProduct.products, selected: parentProduct.selected }"
                class="tab"
                @mouseleave="closeTabMenu"
            >
                <span
                    v-if="!parentProduct.products"
                    class="tab-text tab-option"
                    @click="(evt) => route(evt, parentProduct)"
                >
                    <span class="tab-link">{{ $t(parentProduct.label) }}</span>
                </span>
                <template v-else>
                    <span class="tab-text tab-option tab-display" @click="toggleTabMenu(parentProduct.name)">
                        <span class="tab-link">{{ $t(parentProduct.label) }}</span>
                    </span>
                    <div class="tab-dropdown-button">
                        <span class="menu-arrow" @click="toggleTabMenu(parentProduct.name)">+</span>
                    </div>
                    <ul v-show="tabMenuOpen === parentProduct.name" class="tab-menu">
                        <template v-for="product in parentProduct.products">
                            <li v-if="product.products" :id="'tab_' + product.name" class="tab-menu-item">
                                <span class="tab-option" @mouseleave="closeTabSubMenu">
                                    <a class="tab-menu-click" @click="toggleTabSubMenu(product.name)">
                                        <b>{{ $t(product.label) }}</b>
                                    </a>
                                    <ul v-show="tabSubMenuOpen === product.name" class="tab-submenu">
                                        <li
                                            v-for="subProduct in product.products"
                                            :id="'tab_' + subProduct.name"
                                            :class="{ selected: subProduct.selected }"
                                            class="tab-menu-item"
                                        >
                                            <span class="tab-option">
                                                <a
                                                    :href="subProduct.link"
                                                    class="tab-menu-link"
                                                    @click="(evt) => route(evt, subProduct)"
                                                >
                                                    {{ $t(subProduct.label) }}
                                                </a>
                                            </span>
                                        </li>
                                    </ul>
                                </span>
                            </li>
                            <li
                                v-else
                                :id="'tab_' + product.name"
                                :class="{ selected: product.selected }"
                                class="tab-menu-item"
                            >
                                <span class="tab-option">
                                    <a :href="product.link" class="tab-menu-link" @click="(evt) => route(evt, product)">
                                        {{ $t(product.label) }}
                                    </a>
                                </span>
                            </li>
                        </template>
                    </ul>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'TabMenu',
        props: {
            menu: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                tabMenuOpen: null,
                tabSubMenuOpen: null,
            };
        },
        methods: {
            closeTabMenu() {
                setTimeout(() => {
                    this.tabMenuOpen = null;
                    this.tabSubMenuOpen = null;
                }, 4000);
            },

            closeTabSubMenu() {
                setTimeout(() => {
                    this.tabSubMenuOpen = null;
                }, 4000);
            },

            route(evt, option) {
                evt.preventDefault();
                this.$store.navigate(option);
            },

            toggleTabMenu(name) {
                this.tabSubMenuOpen = null;
                if (this.tabMenuOpen === name) {
                    this.tabMenuOpen = null;
                } else {
                    this.tabMenuOpen = name;
                }
            },

            toggleTabSubMenu(name) {
                if (this.tabSubMenuOpen === name) {
                    this.tabSubMenuOpen = null;
                } else {
                    this.tabSubMenuOpen = name;
                }
            },
        },
    };
</script>
